import { TimeOffsetToMinutes, TimeOffset, DayUnits } from '../../services/constants';
import { DateTime } from 'luxon';
import _ from 'lodash';


export const handleCommonRelativeTimeChange = (time, onChange, timeSpan) => {
  if (time === TimeOffset.CUSTOM) {
    onChange(timeSpan);
  } else if (TimeOffsetToMinutes[time]) {
    const from = DateTime.now();
    onChange({ from: from.minus({ minute: TimeOffsetToMinutes[time] }), to: DateTime.now() });
  }
};

export const handleRelativeDateUnitSwitch = (unit, date, relativeData) => {
  const lastNumber = _.toSafeInteger(relativeData.lastNumber);
  return date.minus({ [unit]: lastNumber });
};

export const getRelativeDate = (relativeData) => {
  let from = DateTime.now();
  let to = DateTime.now();

  const relativeHours = _.toSafeInteger(relativeData.hours);
  from = from.minus({ hours: relativeHours });
  to = to.minus({ hours: relativeHours });
  switch (relativeData.relativeTo) {
    case DayUnits.TODAY:
      from = handleRelativeDateUnitSwitch(relativeData.unit, from, relativeData);
      break;

    case DayUnits.YESTERDAY:
      from = from.minus({ day: 1 });
      to = to.minus({ day: 1 });
      from = handleRelativeDateUnitSwitch(relativeData.unit, from, relativeData);
      break;

    default:
      break;
  }

  return { from, to };
};


export const formatDates = (timeSpan) => {
  const formatObject = {
    weekday: 'short',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  };
  if (!_.isEmpty(timeSpan)) {
    return {
      from: timeSpan.from.toLocaleString(formatObject),
      to: timeSpan.to.toLocaleString(formatObject)
    };
  }
  return {
    from: DateTime.now().toLocaleString(formatObject),
    to: DateTime.now().toLocaleString(formatObject)
  };

};
